import { Button } from '@chakra-ui/react'
import { trackEvent } from '@lib/clinician-tracking'
import React from 'react'

export const ShareLinkButton = ({
  url,
  icon,
  title,
  buttonType,
  onClick
}: {
  url: string
  icon: any
  title: string
  buttonType: string
  onClick?: (e?: React.MouseEvent) => void
}) => {
  const handleClick = (e: React.MouseEvent) => {
    trackEvent('Referral V3 -> Clicked Share Button', {
      shareMethod: buttonType,
      platform: 'mobile'
    })

    if (onClick && !url) {
      onClick(e)
      e.preventDefault()
      return false
    }
  }

  const isCustomAction = !url

  const commonProps = {
    margin: '0px',
    variant: 'outline' as const,
    isFullWidth: true,
    borderColor: 'pale_gray',
    leftIcon: icon,
    colorScheme: 'gray',
    size: 'lg' as const,
    _hover: {
      bg: 'pale_gray'
    },
    _focus: {
      outline: 'none'
    },
    onClick: handleClick,
    children: title
  }

  if (isCustomAction) {
    return <Button {...commonProps} as="button" />
  }

  return <Button {...commonProps} as="a" href={url} target="_blank" />
}
